import Mixpanel from 'mixpanel-browser';
import { MIXPANEL_TOKEN, APP_ENV } from '../config';

function noop() { }

var mixpanel: any = {
  init: noop,
  track: noop,
  register: noop,
  reset: noop,
};

export function initMixpanel() {
  if (APP_ENV === 'production' && MIXPANEL_TOKEN) {
    Mixpanel.init(MIXPANEL_TOKEN);
    mixpanel = Mixpanel;
  }
}

export function track(name: string, props?: Record<string, unknown>) {
  mixpanel.track(name, props);
}

export function register(props?: Record<string, unknown>) {
  mixpanel.register(props);
}

export function reset() {
  mixpanel.reset();
}
